import React from 'react';
import IconWrap from '../IconWrap';
const CorePickerTwinkle = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        width: "0",
        height: "0",
        viewBox: "0 0 19 19",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("path", {
        d: "M12.3458 12.3438H6.17188v6.1741h6.17392v-6.1741ZM18.5255 6.17188h-6.1739v6.17422h6.1739V6.17188Z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6.17391 6.17188H0v6.17422h6.17391V6.17188Z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M12.3458 0H6.17188v6.17419h6.17392V0Z"
    }))));
CorePickerTwinkle.displayName = 'CorePickerTwinkle';
export default CorePickerTwinkle;

//# sourceMappingURL=CorePickerTwinkle.js.map